import once from 'transmute/once';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
function createAsyncData() {
  // @ts-expect-error intentional, need a status that will not overlap with any other interpretation
  return new AsyncData({
    status: 'DEFERRED'
  });
}
export const deferredAsyncDataSelector = once(createAsyncData);